import React, { createContext, useContext, useEffect, useState } from 'react';
import { reportError } from '../lib/errorReporter';

const WatchlistContext = createContext(null);
const KEY = 'poc.watchlist.v1';

export function WatchlistProvider({ children }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {
      reportError('Watchlist.read', e);
    }
  }, []);
  const save = (next) => {
    setItems(next);
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      reportError('Watchlist.write', e);
    }
  };
  const toggle = (entity) => {
    const id = `${entity.kind}:${entity.slug}`;
    const exists = items.find((i) => i.id === id);
    if (exists) save(items.filter((i) => i.id !== id));
    else save([{ ...entity, id, addedAt: Date.now() }, ...items]);
  };
  const isWatched = (kind, slug) => items.some((i) => i.id === `${kind}:${slug}`);
  return (
    <WatchlistContext.Provider value={{ items, toggle, isWatched, clear: () => save([]) }}>
      {children}
    </WatchlistContext.Provider>
  );
}

export function useWatchlist() {
  return useContext(WatchlistContext);
}
